import { cn } from '@/utils/tailwind-util';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import { useEffect, useRef, useState } from 'react';

import ClickOutside from '@/components/ClickOutside';
import Transition from '@/components/Transition';

import {
  useStaticDropdownAction,
  useStaticDropdownState,
} from '../states/useStaticDropdown';

interface Props {
  id: string;
  refElement: JSX.Element;
  disabled: boolean;
  dropSide?: 'left' | 'right';
  useClickOutside: boolean;
  btnHeight: number;
  isOpen: boolean;
  onToggleDropdown: (id: string) => void;
}

const DropDownComponent = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      id,
      refElement,
      disabled,
      dropSide,
      children,
      btnHeight,
      isOpen,
      onToggleDropdown,
    },
    buttonRef
  ) => (
    <>
      <div
        id={id}
        ref={buttonRef}
        role="presentation"
        onClick={() => onToggleDropdown(id)}
        className="z-100 group"
      >
        {refElement}
      </div>

      {!disabled && isOpen ? (
        <div
          style={{
            top: btnHeight,
            [dropSide as string]: 0,
          }}
          className="absolute bg-white rounded shadow-lg py-2 z-40 mt-1"
        >
          <Transition
            show={isOpen}
            enter={'transition duration-100 ease-out'}
            enterFrom={'transform scale-95 opacity-0'}
            enterTo={'transform scale-100 opacity-100'}
            leave={'transition duration-75 ease-in'}
            leaveFrom={'transform scale-100 opacity-100'}
            leaveTo={'transform scale-95 opacity-0'}
          >
            {React.Children.only(children)}
          </Transition>
        </div>
      ) : (
        <></>
      )}
    </>
  )
);

DropDownComponent.displayName = 'DropDownComponent';

const DropdownStatic: React.FC<Props> = ({
  id,
  refElement,
  disabled = false,
  dropSide = 'left',
  children,
  useClickOutside = false,
}) => {
  const { onToggleDropdown } = useStaticDropdownAction();
  const dropdown = useStaticDropdownState();

  const buttonRef = useRef<HTMLElement>(null);
  const [btnHeight, setBtnHeight] = useState(0);

  useEffect(() => {
    const buttonEl = document.getElementById(id);

    if (buttonEl) {
      setBtnHeight(buttonEl.clientHeight);
    }
  }, [id]);

  const isOpen = (dropdown && dropdown[id]) || false;

  const props = {
    id,
    refElement,
    disabled,
    dropSide,
    children,
    btnHeight,
    isOpen,
    onToggleDropdown,
  };

  return (
    <div className="relative">
      {useClickOutside ? (
        <ClickOutside
          isOpen={isOpen}
          toggleAreaRef={buttonRef}
          onClickOutside={() => onToggleDropdown(id)}
        >
          <DropDownComponent {...props} buttonRef={buttonRef} />
        </ClickOutside>
      ) : (
        <DropDownComponent {...props} buttonRef={buttonRef} />
      )}
    </div>
  );
};

export default DropdownStatic;
